import React from 'react'
import './Services.scss';

const Services = () => {
  return (
    <div className="services min-h-screen py-20">
      <div className="flex flex-col justify-center items-center">
        <div>
          <h1 className="animate-charcter ">SERVICES</h1>
        </div>
        {/* Services  */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 mx-5 gap-x-5 gap-y-5 mt-20 lg:mx-40 md:mx-20 leading-relaxed">
          <div
            data-aos="zoom-in"
            className=" hover:bg-slate-800 ease-in duration-200 p-5 rounded text-emerald-50 ring-1 shadow-lg shadow-slate-700/100 "
          >
            <h1 className="font font-bold hover:text-green-500 text-2xl pb-3 ">
              <span className="mr-2">❖</span>
              Full Website Creation
            </h1>
            <p className="">
              I will create any kind of website -- Company Website, Ecommerce
              Store, Business, Portfolio, Blog Site, etc. I will deliver
              professional and modern Website Design that will promote your
              brand frequently. I complete all my project with absolute devotion
              and perfection.
            </p>
          </div>
          <div
            data-aos="zoom-in"
            className=" hover:bg-slate-800 ease-in duration-200 p-5 rounded text-emerald-50 ring-1 shadow-lg shadow-slate-700/100"
          >
            <h1 className="font font-bold hover:text-green-500 text-2xl pb-3">
              <span className="mr-2">❖</span>
              Landing Page
            </h1>
            <p>
              I will create any kind of Landing Page -- I will deliver
              professional and modern Landing Page that will promote your brand
              frequently. I complete all my project with absolute devotion and
              perfection.
            </p>
          </div>
          <div
            data-aos="zoom-in"
            className=" hover:bg-slate-800 ease-in duration-200 p-5 rounded text-emerald-50 ring-1 shadow-lg shadow-slate-700/100"
          >
            <h1 className="font font-bold hover:text-green-500 text-2xl pb-3">
              <span className="mr-2">❖</span>
              Convert Figma, PSD to React/HTML Responsive Webpage
            </h1>
            <p>
              Looking for someone to convert your Figma, PSD design to a
              responsive, professional, and pixel-perfect React.js website? I
              will use Tailwind-CSS, Bootstrap, Material-UI, etc.
            </p>
          </div>
          <div
            data-aos="zoom-in"
            className=" hover:bg-slate-800 ease-in duration-200 p-5 rounded text-emerald-50 ring-1 shadow-lg shadow-slate-700/100"
          >
            <h1 className="font font-bold hover:text-green-500 text-2xl pb-3">
              <span className="mr-2">❖</span>
              Fixing Error
            </h1>
            <p>
              I will solve the errors in Javascript,HTML, CSS, React js, Node
              js. If you have any bug in your website/application/program/code,
              I will solve your bug!!
            </p>
          </div>
          <div
            data-aos="zoom-in"
            className=" hover:bg-slate-800 ease-in duration-200 p-5 rounded text-emerald-50 ring-1 shadow-lg shadow-slate-700/100"
          >
            <h1 className="font font-bold hover:text-green-500 text-2xl pb-3">
              <span className="mr-2">❖</span>
              Maintenance and Support
            </h1>
            <p>
              I will provide end-to-end maintainance and suport for
              uninterrupted performance of your websites/apps.I will actively
              support you with improving your business by maintaining your
              website so you don't have to bother about anything anymore.
            </p>
          </div>
          <div
            data-aos="zoom-in"
            className=" hover:bg-slate-800 ease-in duration-200 p-5 rounded text-emerald-50 ring-1 shadow-lg shadow-slate-700/100"
          >
            <h1 className="font font-bold hover:text-green-500 text-2xl pb-3">
              <span className="mr-2">❖</span>
              Responsive Design
            </h1>
            <p>
              My services include building responsive and user-friendly websites
              with complete source code, documentation and support
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Services